import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPageBySlug } from '../lib/dataService';
import { Users, Target, Award, ArrowRight } from 'lucide-react';

const SUB_PAGES = [
  { icon: Award, title: 'History – Video', desc: 'Watch the documentary of Cayman Basketball.', to: '/page/history-video' },
  { icon: Target, title: 'Objectives', desc: 'The goals that drive our association forward.', to: '/page/objectives' },
  { icon: Users, title: 'Committees', desc: 'Meet the people behind CIBA.', to: '/page/committees' },
];

export default function AboutPage() {
  const [page, setPage] = useState(null);

  useEffect(() => {
    getPageBySlug('about-us').then(setPage);
  }, []);

  return (
    <div className="static-page">
      <div className="page-hero">
        <div className="container">
          <span className="page-hero-label">Who We Are</span>
          <h1>About Us</h1>
          <p>The governing body for basketball in the Cayman Islands.</p>
        </div>
      </div>

      <div className="container article-body-wrap section">
        {page ? (
          <div className="wp-content" dangerouslySetInnerHTML={{ __html: page.content }} />
        ) : (
          <div className="loading-block" />
        )}
      </div>

      <div className="container section about-subpages">
        <h2 className="section-title">Explore More</h2>
        <div className="quick-links-grid three">
          {SUB_PAGES.map((s) => {
            const Icon = s.icon;
            return (
              <Link key={s.to} to={s.to} className="quick-card">
                <div className="quick-icon"><Icon size={26} /></div>
                <div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                </div>
                <ArrowRight size={16} className="league-arrow" />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
